import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Public API - no auth headers/cookies
const publicApi = axios.create({
    baseURL: API,
    withCredentials: false,
});

export default publicApi;
